import { QuoteExtras } from '~/lib/types/basket-types';
import useBasketSection from '~/hooks/use-basket-section';
import { FC } from 'react';
import Section from '~/components/core/section/section';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { BasketSections } from '~/lib/types/enums';

import { BaseModuleProps } from './module-factory';
import Extras from '~/components/extras/extras';
import { Upsell } from '~/lib/types/extra-types';

const ExtrasModule: FC<BaseModuleProps> = ({ wrapper }) => {
  const { t } = useTranslation([TranslationNamespaces.CHECKOUT]);
  const section = useBasketSection<QuoteExtras>({ name: BasketSections.EXTRAS });

  return (
    <Extras
      limitToExtras={[Upsell.GUARANTEE]}
      wrapper={(x) =>
        wrapper(
          <Section
            title={t('EXTRAS_TITLE', { defaultValue: 'Add These Options to Your Delivery' })}
            dataTestId="extras-section"
            loading={section.loading}
          >
            {x}
          </Section>
        )
      }
    />
  );
};

export default ExtrasModule;
